module.exports = __webpack_public_path__ + "static/img/h1.e40c27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h1.jpg
// module id = chkI
// module chunks = 0